/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 * @description   Short-term cancellation bizos
 */

import { Bizo, autoclass } from './base'
import type {
  RawShortTermPolicies,
  RawShortTermPoliciesCheckInOut,
  RawShortTermPoliciesV1,
  RawShortTermPolicy,
  ShortTermPoliciesCheckInOut as ShortTermPoliciesCheckInOutType,
  ShortTermPolicies as ShortTermPoliciesType,
  ShortTermPoliciesV1 as ShortTermPoliciesV1Type,
  ShortTermPolicy as ShortTermPolicyType,
} from './shortTermPolicies.types'

export const ShortTermPoliciesCheckInOut: typeof ShortTermPoliciesCheckInOutType = autoclass<
  ShortTermPoliciesCheckInOutType,
  RawShortTermPoliciesCheckInOut
>(
  'ShortTermPoliciesCheckInOut',
  class ShortTermPoliciesCheckInOut extends Bizo<
    ShortTermPoliciesCheckInOutType,
    RawShortTermPoliciesCheckInOut
  > {},
  {
    startTime: 'start_time',
    endTime: 'end_time',
    description: 'description',
    instructions: 'instructions',
  }
)

export type ShortTermPoliciesCheckInOut = ShortTermPoliciesCheckInOutType

export const ShortTermPolicy = autoclass<ShortTermPolicyType, RawShortTermPolicy>(
  'ShortTermPolicy',
  class ShortTermPolicy extends Bizo<ShortTermPolicyType, RawShortTermPolicy> {},
  {
    checkIn: { name: 'check_in', type: ShortTermPoliciesCheckInOut },
    checkOut: { name: 'check_out', type: ShortTermPoliciesCheckInOut },
    generalPolicies: 'general_policies',
  }
)

export type ShortTermPolicy = ShortTermPolicyType

export const ShortTermPoliciesV1 = autoclass<ShortTermPoliciesV1Type, RawShortTermPoliciesV1>(
  'ShortTermPoliciesV1',
  class ShortTermPoliciesV1 extends Bizo<ShortTermPoliciesV1Type, RawShortTermPoliciesV1> {},
  {
    v1: { name: 'v1', type: ShortTermPolicy },
  }
)

export const ShortTermPolicies = autoclass<ShortTermPoliciesType, RawShortTermPolicies>(
  'ShortTermPolicies',
  class ShortTermPolicies extends Bizo<ShortTermPoliciesType, RawShortTermPolicies> {},
  {
    policies: { name: 'policies', type: ShortTermPoliciesV1 },
  }
)
export type ShortTermPolicies = ShortTermPoliciesType
